type RegisterNextButtonHandler = (instance: unknown) => void;

const handlers = new Set<RegisterNextButtonHandler>();

export function onRegisterNextButton(handler: RegisterNextButtonHandler): () => void {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export function emitRegisterNextButton(instance: unknown): void {
  handlers.forEach((handler) => handler(instance));
}
